import showToast from './showToast.operation';
import dismissToast from './dismissToast.operation';

export default {
  showToast,
  dismissToast,
};
